module.exports = __webpack_public_path__ + "img/12.38078d13.jpg";